import { Component, OnInit } from '@angular/core';
import { Vozilo } from './vozilo';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-vozilo-update',
  templateUrl: './vozilo-update.component.html'
})
export class VoziloUpdateComponent extends BaseUpdateComponent<Vozilo> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'VOZILO.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'VOZILO.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("VrstaVozilaId", Validators.required, 'required', 'VOZILO.VRSTAVOZILA.VALIDATION.REQUIRED');
    this.addValidatorToFc("RgBr", Validators.maxLength(50), 'maxlength', 'VOZILO.RGBR.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("BrSbDozv", Validators.maxLength(50), 'maxlength', 'VOZILO.BRSBDOZV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Marka", Validators.maxLength(30), 'maxlength', 'VOZILO.MARKA.VALIDATION.MAXLENGTH'); 
    this.addValidatorToFc("Model", Validators.maxLength(20), 'maxlength', 'VOZILO.MODEL.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Boja", Validators.maxLength(50), 'maxlength', 'VOZILO.MODEL.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("BrojSasije", Validators.maxLength(50), 'maxlength', 'VOZILO.MODEL.VALIDATION.MAXLENGTH');

  }

}
